var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.01611,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.01611,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#CFCBC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.95361C21.0742 9.95361 21.6074 10.2817 21.8945 10.7739L30.7539 25.8677C31.041 26.4009 31.041 27.0161 30.7539 27.5083C30.4668 28.0415 29.9336 28.3286 29.3594 28.3286H11.6406C11.0254 28.3286 10.4922 28.0415 10.2051 27.5083C9.91797 27.0161 9.91797 26.4009 10.2051 25.8677L19.0645 10.7739C19.3516 10.2817 19.8848 9.95361 20.5 9.95361ZM20.5 15.2036C19.9258 15.2036 19.5156 15.6548 19.5156 16.188V20.7817C19.5156 21.356 19.9258 21.7661 20.5 21.7661C21.0332 21.7661 21.4844 21.356 21.4844 20.7817V16.188C21.4844 15.6548 21.0332 15.2036 20.5 15.2036ZM21.8125 24.3911C21.8125 23.6938 21.1973 23.0786 20.5 23.0786C19.7617 23.0786 19.1875 23.6938 19.1875 24.3911C19.1875 25.1294 19.7617 25.7036 20.5 25.7036C21.1973 25.7036 21.8125 25.1294 21.8125 24.3911Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a042d76af1686dc2e233e36c633577a2.svg";
export { ForwardRef as ReactComponent };